import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {UserNotificationPreferencesDialogController} from "./dialog/UserNotificationPreferencesDialogController";

export class UserNotificationPreferencesDialogService {

    public static id = "userNotificationPreferencesDialogService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public async open(): Promise<void> {
        const options: IModalSettings = {
            templateUrl: "app/notifications/services/preferences-dialog/dialog/UserNotificationPreferencesDialogTemplate.html",
            controller: UserNotificationPreferencesDialogController,
            controllerAs: "ctrl",
            windowClass: "user-notification-preferences-dialog"
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}
